<script>
	import { Router, Link, Route, links } from "svelte-routing";
	import Reel from './Reel.svelte';
	import Index from './Index.svelte';
	import BookPage from './BookPage.svelte';
	import Explore from './Explore.svelte';
	import UserBar from './UserBar.svelte';
	import SearchBar from './SearchBar.svelte';
	import Search from './Search.svelte';

	export let url = "";
</script>

<style>

	#container {
		/*margin-top: 50px;*/

		/*background: #FFF;*/
		margin: 10px 10px;
		margin-bottom: 100px;
		border-radius: 20px;
	}
</style>


<div use:links>
	<Router url="{url}">
		<!-- <SearchBar /> -->

		<Route path="/book/:id" let:params>
			<div id="container">
				<BookPage id={params.id} />
			</div>
			<UserBar />
		</Route>

		<Route path="/explore/:category" let:params>
			<div id="container">
				<Explore category={params.category} />
			</div>
			<UserBar />
		</Route>

		<Route path="/search/:term" let:params>
			<div id="container">
				<Search term={params.term} />
			</div>
			<UserBar />
		</Route>

		<Route path="/" let:params>
			<div id="container">
				<Index />
			</div>
			<UserBar back={false} />
		</Route>
		<!-- 
		<div id="container">
			<Route path="/book/:id" let:params><BookPage id={params.id} /></Route>
			<Route path="/explore/:category" let:params><Explore category={params.category} /></Route>
			<Route path="/"><Index /></Route>
		</div> -->

		
	</Router>
</div>
